/* eslint-disable no-use-before-define */
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
} from 'react';
import PropTypes from 'prop-types';
import AppBar from 'material-ui/AppBar';
import Tabs from 'material-ui/Tabs';
import Tab from 'material-ui/Tabs/Tab';

import { useLazyLoad } from '../../../hocs/useLazyLoad';
import EmptyContent from '../../common/EmptyState/Content';
import ActivitiesList from '../Components/ActivitiesList/index';
import { isDesktop } from '../../../utils/mobileHelpers';
import { COLORS } from '../../../constants/styles';
import { enhance } from './enhance';
import Loader from '../../common/Loader/index';
import {
  COMMON,
  COMMUNITIES_COMMON,
  COMMUNITIES_EMPTY_ACTIVITIES,
} from '../../../constants/strings';
import { ACTIVITY_TYPES } from '../../../constants';
import { IDS } from '../../../constants/ids';

const Activities = ({
  joinReqCounter,
  invitesCounter,
  notifyCounter,
  sendingJoinRequests,
  pageLeave,
  communitiesJoinReq,
  loadNextRequests,
  intl: { formatMessage },
  classes,
  hasNotifications,
  changeTab,
  tab,
  list,
}) => {
  const rootRef = useRef();
  const tabs = useTabs(
    formatMessage,
    notifyCounter,
    joinReqCounter,
    invitesCounter,
  );
  const loadMore = useCallback(() => {
    loadNextRequests({ limit: 5, type: tab });
  }, [tab]);
  useLazyLoad({ node: rootRef, loadMore, path: ['parentNode'] });
  useEffect(() => {
    communitiesJoinReq({ limit: 10, type: ACTIVITY_TYPES.JOIN_REQUESTS });
    communitiesJoinReq({ limit: 10, type: ACTIVITY_TYPES.MEMBER_INVITATIONS });
    communitiesJoinReq({ limit: 10, type: ACTIVITY_TYPES.NOTIFICATIONS });

    return () => {
      pageLeave();
    };
  }, []);

  return (
    <div styleName="wrapper" className="flex flex-column" ref={rootRef}>
      <Choose>
        <When condition={!sendingJoinRequests}>
          <If condition={hasNotifications}>
            <Fragment>
              <AppBar
                position="static"
                color="default"
                style={{
                  background: 'transparent',
                  border: 0,
                  boxShadow: 'none',
                  marginLeft: isDesktop() && '-56px',
                  marginTop: 16,
                }}
              >
                <Tabs
                  indicatorColor={COLORS.bluePrimary}
                  onChange={(e, value) => changeTab(value)}
                  value={tab}
                  scrollable
                >
                  {tabs.map(({ id, counter, label, tab: tabValue }) => (
                    <If condition={!!counter}>
                      <Tab
                        label={`${label} (${counter})`}
                        key={id}
                        id={id}
                        value={tabValue}
                        classes={{
                          root: classes.root,
                          label: classes.label,
                        }}
                      />
                    </If>
                  ))}
                </Tabs>
              </AppBar>
              <ActivitiesList
                className="w-100 flex-grow-1"
                list={list}
                listType={tab}
              />
            </Fragment>
            <Else />
            <div styleName="empty-state">
              <EmptyContent
                text={formatMessage(COMMUNITIES_EMPTY_ACTIVITIES)}
                icon="icon-megaphone"
              />
            </div>
          </If>
        </When>
        <Otherwise>
          <Loader />
        </Otherwise>
      </Choose>
    </div>
  );
};

Activities.propTypes = {
  changeTab: PropTypes.func.isRequired,
  hasNotifications: PropTypes.bool.isRequired,
  tab: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired,
  communitiesJoinReq: PropTypes.func.isRequired,
  joinReqCounter: PropTypes.number,
  invitesCounter: PropTypes.number,
  notifyCounter: PropTypes.number,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  classes: PropTypes.object.isRequired,
  sendingJoinRequests: PropTypes.bool,
  loadNextRequests: PropTypes.func.isRequired,
  pageLeave: PropTypes.func.isRequired,
};

Activities.defaultProps = {
  joinReqCounter: 0,
  invitesCounter: 0,
  notifyCounter: 0,
  sendingJoinRequests: false,
};

export default enhance(Activities);

function useTabs(
  formatMessage,
  notificationCounter,
  requestsCounter,
  invitesCounter,
) {
  return useMemo(
    () => [
      {
        label: formatMessage(COMMON.notifications),
        id: IDS.ACTIVITIES_TABS.NOTIFICATIONS,
        tab: ACTIVITY_TYPES.NOTIFICATIONS,
        counter: notificationCounter,
      },
      {
        label: formatMessage(COMMUNITIES_COMMON.joinRequests),
        id: IDS.ACTIVITIES_TABS.JOIN_REQUESTS,
        tab: ACTIVITY_TYPES.JOIN_REQUESTS,
        counter: requestsCounter,
      },
      {
        label: formatMessage(COMMUNITIES_COMMON.invites),
        id: IDS.ACTIVITIES_TABS.MEMBER_INVITATIONS,
        tab: ACTIVITY_TYPES.MEMBER_INVITATIONS,
        counter: invitesCounter,
      },
    ],
    [notificationCounter, requestsCounter, invitesCounter],
  );
}



// WEBPACK FOOTER //
// ./src/components/Communities/Activities/index.jsx